import bellSrc from '../icons/notification-bell.svg'
import dotSrc from '../icons/notification-dot.svg'
import { IconButton } from './icon-button'
import type { IconButtonProps } from './icon-button'

interface NotificationButtonProps extends Omit<IconButtonProps, 'children' | 'aria-label'> {
	hasNotification?: boolean
	'aria-label'?: string
}

function NotificationButton({ hasNotification = false, 'aria-label': ariaLabel = 'Notifications', ...props }: NotificationButtonProps) {
	return (
		<IconButton variant="secondary" size="md" aria-label={ariaLabel} {...props}>
			<span className="relative flex size-4 items-center justify-center">
				<img src={bellSrc} alt="" className="size-full" />
				{hasNotification && (
					<img
						src={dotSrc}
						alt=""
						className="absolute -top-0.5 -right-0.5 size-2"
					/>
				)}
			</span>
		</IconButton>
	)
}

export { NotificationButton }
export type { NotificationButtonProps }
